import { render, staticRenderFns } from "./CreateEventAction.vue?vue&type=template&id=6a025970"
import script from "./CreateEventAction.vue?vue&type=script&lang=js"
export * from "./CreateEventAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports